import * as React from 'react'
import { Icons, Typography } from '@lacedltd/laced-components'
import { useTranslation } from 'hooks'
import * as S from './AccountMenuSection.styles'
import type { AccountSidebarSection } from './accountSections'

interface AccountMenuSectionProps {
  sections: AccountSidebarSection[]
  onBack: () => void
}

const AccountMenuSection: React.FC<AccountMenuSectionProps> = ({
  sections,
  onBack
}) => {
  const { t } = useTranslation()

  return (
    <>
      <S.BackButton fullWidth variant="tertiary" onClick={onBack}>
        <Icons.Left size="m" />{' '}
        <Typography.Text variant="body" color="airJordan.p">
          {t('react_components.top_nav.my_account')}
        </Typography.Text>
      </S.BackButton>

      <S.ContentSection>
        {sections.map((section) => (
          <S.Section key={section.label}>
            <S.SectionLabel>{section.label}</S.SectionLabel>
            {section.items.map((item) => (
              <S.NavLink
                key={item.href}
                href={item.href}
                data-active={item.active || undefined}
              >
                {item.label}
                {item.count != null && item.count !== 0 && (
                  <S.NotificationDot />
                )}
              </S.NavLink>
            ))}
          </S.Section>
        ))}
      </S.ContentSection>
    </>
  )
}

export default AccountMenuSection
